import { render, staticRenderFns } from "./NirRegistryBreakdown.vue?vue&type=template&id=5fb7dc6e&scoped=true&"
import script from "./NirRegistryBreakdown.vue?vue&type=script&lang=js&"
export * from "./NirRegistryBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb7dc6e",
  null
  
)

export default component.exports